import { render, staticRenderFns } from "./TzList.vue?vue&type=template&id=5c039cb8"
import script from "./TzList.vue?vue&type=script&lang=js"
export * from "./TzList.vue?vue&type=script&lang=js"
import style0 from "./TzList.vue?vue&type=style&index=0&id=5c039cb8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports